/**
 * Embed Page
 * Isolated page mainly for iframe usage
 */

import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ChatWidget from '../components/ChatWidget/ChatWidget';

function EmbedPage() {
    const { brandId } = useParams();
    const [searchParams] = useSearchParams();
    // ?open=1 auto-launches the chat (used by host sites embedding a dedicated concierge page).
    const autoOpen = searchParams.get('open') === '1';

    // Verify brandId exists or fetch brand name? 
    // For MVP we just pass the ID. The widget handles the rest.
    // We default name to 'Support' until loaded, or let widget handle it.

    // Force transparent body for iframe
    React.useEffect(() => {
        document.body.style.backgroundColor = 'transparent';
        return () => {
            document.body.style.backgroundColor = '';
        };
    }, []);

    return (
        <div style={{ backgroundColor: 'transparent' }}>
            {/* 
                We pass brandId. 
                In a real app, we might fetch the brand name here 
                so the widget title is correct immediately.
             */}
            <ChatWidget
                brandId={brandId}
                brandName="Customer Support" // The widget will load history and ideally update this
                autoOpen={autoOpen}
            />
        </div>
    );
}

export default EmbedPage;
